import { render, staticRenderFns } from "./ArtistManage.vue?vue&type=template&id=5e239ee6&scoped=true"
import script from "./ArtistManage.vue?vue&type=script&lang=js"
export * from "./ArtistManage.vue?vue&type=script&lang=js"
import style0 from "./ArtistManage.vue?vue&type=style&index=0&id=5e239ee6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e239ee6",
  null
  
)

export default component.exports